import React from 'react';
import Localize from 'react-intl-universal';

import { get } from 'lodash-es';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { alpha } from '@mui/material';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';

const StyleBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    top: '6px',
    right: '6px'
  }
}));
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: alpha(get(theme?.palette?.primary, 'main'), 0.4)
  }
}));

const FilterButton = ({ isFilterOn, setShowFilters, showFilters }) => {
  return (
    <>
      {isFilterOn && (
        <Tooltip title={Localize.get('Catalog.showFilters')} arrow>
          <StyleBadge badgeContent='on'>
            <StyledIconButton onClick={() => setShowFilters(!showFilters)}>
              <FilterAltIcon />
            </StyledIconButton>
          </StyleBadge>
        </Tooltip>
      )}
      {!isFilterOn && (
        <Tooltip title={Localize.get('Catalog.showFilters')} arrow>
          <StyledIconButton onClick={() => setShowFilters(!showFilters)}>
            <FilterAltIcon />
          </StyledIconButton>
        </Tooltip>
      )}
    </>
  );
};

export default FilterButton;
